import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";

const Chapter10 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);
    return (
        <>

             {/* Chapter 10 */}
                <section id="section10" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">
                        {language.chapter10Title}
                    </h2>

                    <ul className="drivers-handbook-list">
                        <li>
                             {language.chapter10List11}
                        </li>
                        <li> {language.chapter10List12}</li>
                    </ul>

                    <h3 className="drivers-handbook-subheading">
                        {language.chapter10Subheading1}
                    </h3>
                    <ul className="drivers-handbook-list">
                        <li>{language.chapter10List21}</li>
                        <li>{language.chapter10List22}</li>
                        <li>
                            {language.chapter10List23}
                        </li>
                        <li>
                            {language.chapter10List24}
                        </li>
                        <li>{language.chapter10List25}</li>
                        <li>{language.chapter10List26}</li>
                    </ul>

                    <h3 className="drivers-handbook-subheading">
                       {language.chapter10Subheading2}
                    </h3>
                    <ul className="drivers-handbook-list">
                        <li>{language.chapter10List31}</li>
                        <li>
                            {language.chapter10List32}

                        </li>
                        <li>
                            {language.chapter10List33}
                        </li>
                        <li>
                            {language.chapter10List34}
                        </li>
                        <li>
                           {language.chapter10List35}
                        </li>
                        <li>
                           {language.chapter10List36}

                        </li>
                        <li>{language.chapter10List37}</li>
                        <li>
                            {language.chapter10List38}
                        </li>
                        <li>{language.chapter10List39}</li>
                        <li>{language.chapter10List40}</li>
                        <li>
                            {language.chapter10List41}
                        </li>
                        <li>
                            හ{language.chapter10List42}

                        </li>
                        <li>
                            {language.chapter10List43}
                        </li>
                        <li>
                           {language.chapter10List44}
                        </li>
                        <li>
                           {language.chapter10List45}
                        </li>
                        <li>
                            {language.chapter10List46}
                        </li>
                        <li>{language.chapter10List47}
                        </li>

                    </ul>
                </section>
        </>
    )

}

export default Chapter10;
